export const stringMapDefault = {
    calendarDescription: "Date Range Picker",
    selectingEndDate: "Selecting end date",
    selectingStartDate: "Selecting start date",
    errorStartAfterEnd: "Start date cannot be after date",
    errorEndBeforeStart: "End date cannot be before start date"
};
